class CompressorNode extends Weaver.Node

  @className = 'Compressor'

  constructor: (id) ->
    super(id)

  create: (name = "New Compressor", threshold = -50, knee = 40, ratio = 12, attack = 0, release = 0.25) ->
    type = await Weaver.Node.firstOrCreate('Compressor')
    @set('name', name)
    @set('threshold', threshold)
    @set('knee', knee)
    @set('ratio', ratio)
    @set('attack', attack)
    @set('release', release)
    @relation('type').add(type)
    @save()

export default CompressorNode
